// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"LoadingSpinner_spinnerWrapper__2hxYF"};